import React from "react"
export function NonVegMeals(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__non-veg-meals"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M17.25 14a1.25 1.25 0 01.128 2.494l-.128.006-.35-.001a1.5 1.5 0 01-1.215 1.474l-.14.02L15.4 18H4.6a1.5 1.5 0 01-1.493-1.356L3.1 16.5h-.35a1.25 1.25 0 01-.128-2.494L2.75 14h14.5zm0 1H2.75a.25.25 0 00-.057.493l.057.007h1.526l-.16.625-.012.061-.004.064v.25a.5.5 0 00.41.492L4.6 17h10.8a.5.5 0 00.492-.41l.008-.09v-.25l-.004-.064-.012-.061-.16-.624 1.526-.001a.25.25 0 00.057-.493L17.25 15zM8.15 2.315l.073.137a2.12 2.12 0 01-.332 2.347l-.07.073L9.096 7.08A5.391 5.391 0 0115.464 13l-1.012.001a4.388 4.388 0 10-8.688 0H4.752A5.37 5.37 0 016.07 8.802L4.821 6.641l-.042.014A2.116 2.116 0 012.287 5.7a2.114 2.114 0 01.763-2.89l.149-.078c.351-.168.736-.23 1.113-.192l.064.01.025-.062c.177-.395.475-.732.865-.957a2.114 2.114 0 012.885.784zm-2.384.083c-.261.15-.442.401-.51.692l-.021.127a.512.512 0 01-.712.41 1.073 1.073 0 00-.972.05c-.52.3-.696.977-.385 1.515.311.539.986.725 1.505.425l.084-.055.075-.04a.503.503 0 01.637.206l1.365 2.364a5.362 5.362 0 011.26-.72L6.726 5.007a.504.504 0 01.169-.675l.093-.06c.438-.31.575-.944.283-1.45-.31-.538-.986-.724-1.505-.424z"
          fill="currentColor"
          fillRule="nonzero"
          id="prefix__non-veg"
        />
      </g>
    </svg>
  )
}
